export default __webpack_public_path__ + "static/media/undrawNatureFunN9Lv1@3x.ed580cc4.png";